import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './StaticPage.css';

const Blog = () => {
  const { t } = useLanguage();

  return (
    <div className="static-page">
      <section className="static-page-hero">
        <h1>{t('static.blogTitle')}</h1>
      </section>
      <section className="static-page-body">
        <div className="container">
          <p>{t('static.blogBody')}</p>
        </div>
      </section>
    </div>
  );
};

export default Blog;
